export default "__VITE_ASSET__2c326c4b__"